import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 5h-5v5h-5v5h-5v5h-5","key":"svg-0"}]]

const IconStairs = createReactComponent('outline', 'stairs', 'Stairs', __iconNode);

export default IconStairs;